module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image17.42a58d6e.jpg";